import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { ComponentComponent } from "./component/component.component";
import { ComponentAssemblyComponent } from "./component-assembly/component-assembly.component";
import { ComponentStandardComponent } from "./component-standard/component-standard.component";
import { ComponentTechnologyComponent } from "./component-technology/component-technology.component";
import { ComponentDetailsComponent } from "./component-details/component-details.component";
import { ComponentUpdateComponent } from "./component-update/component-update.component";
import { ComponentAddComponent } from "./component-add/component-add.component";

export const COMPONENT_ROUTES: Routes = [
  {
    path: 'components',
    pathMatch: 'full',
    redirectTo: 'component/overview/:active'

  },
  {
    path: 'component/overview/:active',
    component: ComponentComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/passive/:active',
    component: ComponentComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/assembly',
    component: ComponentAssemblyComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/standard',
    component: ComponentStandardComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/technology',
    component: ComponentTechnologyComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/details/:technical_drawing',
    component: ComponentDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/add',
    component: ComponentAddComponent,
    canActivate: [authGuard]
  },
  {
    path: 'component/update/:technical_drawing',
    component: ComponentUpdateComponent,
    canActivate: [authGuard]
  }
];
